// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
var ProductParameters = /* #__PURE__ */ (function () {
    function ProductParameters(value0) {
        this.value0 = value0;
    };
    ProductParameters.create = function (value0) {
        return new ProductParameters(value0);
    };
    return ProductParameters;
})();
var CategoryParameters = /* #__PURE__ */ (function () {
    function CategoryParameters(value0) {
        this.value0 = value0;
    };
    CategoryParameters.create = function (value0) {
        return new CategoryParameters(value0);
    };
    return CategoryParameters;
})();
var ModifierParameters = /* #__PURE__ */ (function () {
    function ModifierParameters(value0) {
        this.value0 = value0;
    };
    ModifierParameters.create = function (value0) {
        return new ModifierParameters(value0);
    };
    return ModifierParameters;
})();
var ParameterParameters = /* #__PURE__ */ (function () {
    function ParameterParameters(value0) {
        this.value0 = value0;
    };
    ParameterParameters.create = function (value0) {
        return new ParameterParameters(value0);
    };
    return ParameterParameters;
})();
var MenuCatalogueMemo = function (x) {
    return x;
};
var hasFieldMenuCatalogueMemo = function (dictHasField) {
    return {
        getField: function (label) {
            return function (v) {
                return Data_Record.getField(dictHasField)(label)(v.catalogue);
            };
        }
    };
};
var genericParametersMemoKey_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new ProductParameters(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new CategoryParameters(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ModifierParameters(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new ParameterParameters(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Memo (line 27, column 1 - line 27, column 44): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof ProductParameters) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CategoryParameters) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ModifierParameters) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof ParameterParameters) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Memo (line 27, column 1 - line 27, column 44): " + [ x.constructor.name ]);
    }
};
var showParametersMemoKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericParametersMemoKey_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))({
        reflectSymbol: function () {
            return "ProductParameters";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))({
        reflectSymbol: function () {
            return "CategoryParameters";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))({
        reflectSymbol: function () {
            return "ModifierParameters";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))({
        reflectSymbol: function () {
            return "ParameterParameters";
        }
    })))))
};
var eqParametersMemoKey = {
    eq: function (x) {
        return function (y) {
            if (x instanceof ProductParameters && y instanceof ProductParameters) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0)(y.value0);
            };
            if (x instanceof CategoryParameters && y instanceof CategoryParameters) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0)(y.value0);
            };
            if (x instanceof ModifierParameters && y instanceof ModifierParameters) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0)(y.value0);
            };
            if (x instanceof ParameterParameters && y instanceof ParameterParameters) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var ordParametersMemoKey = {
    compare: function (x) {
        return function (y) {
            if (x instanceof ProductParameters && y instanceof ProductParameters) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(x.value0)(y.value0);
            };
            if (x instanceof ProductParameters) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ProductParameters) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof CategoryParameters && y instanceof CategoryParameters) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(x.value0)(y.value0);
            };
            if (x instanceof CategoryParameters) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof CategoryParameters) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ModifierParameters && y instanceof ModifierParameters) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(x.value0)(y.value0);
            };
            if (x instanceof ModifierParameters) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof ModifierParameters) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof ParameterParameters && y instanceof ParameterParameters) {
                return Data_Ord.compare(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Menu.V2.Memo (line 29, column 1 - line 29, column 38): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqParametersMemoKey;
    }
};
var toCatalogue = function (v) {
    return v.catalogue;
};
var parametersMemo = function (v) {
    return v.parametersMemo;
};
var memoLookup = function (dictOrd) {
    return function (memoRef) {
        return function (k) {
            return function (compute) {
                return Effect_Unsafe.unsafePerformEffect(function __do() {
                    var memoData = Effect_Ref.read(memoRef)();
                    var v = Data_Map_Internal.lookup(dictOrd)(k)(memoData);
                    if (v instanceof Data_Maybe.Just) {
                        return v.value0;
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        var v1 = compute(Data_Unit.unit);
                        Effect_Ref.modify_(Data_Map_Internal.insert(dictOrd)(k)(v1))(memoRef)();
                        return v1;
                    };
                    throw new Error("Failed pattern match at Restaumatic.Menu.V2.Memo (line 43, column 3 - line 49, column 13): " + [ v.constructor.name ]);
                });
            };
        };
    };
};
var memo = function (catalogue) {
    return {
        catalogue: catalogue,
        parametersMemo: Effect_Unsafe.unsafePerformEffect(Effect_Ref["new"](Data_Map_Internal.empty))
    };
};
export {
    MenuCatalogueMemo,
    toCatalogue,
    ProductParameters,
    CategoryParameters,
    ModifierParameters,
    ParameterParameters,
    parametersMemo,
    memoLookup,
    memo,
    hasFieldMenuCatalogueMemo,
    genericParametersMemoKey_,
    eqParametersMemoKey,
    ordParametersMemoKey,
    showParametersMemoKey
};
//# sourceMappingURL=index.js.map
